export const flatTags = (filterSection: CommonTypes.FilterSectionType[]) =>
  filterSection
    ?.map(({ protectionPicker }) => protectionPicker?.map(({ tags: tag }) => tag))
    .flat();
